import { Http, Response } from '@angular/http';
import { IAppConfig } from './app-config.model';
import {Injectable} from '@angular/core';

@Injectable()
export class AppConfigService {

  static settings: IAppConfig;

  constructor(private http: Http) {}

  load() {
    const jsonFile = '../assets/config/config.json';
    return new Promise<void>((resolve, reject) => {
      this.http.get(jsonFile).toPromise().then((response: Response) => {
        AppConfigService.settings = <IAppConfig>response.json();
        resolve();
      }).catch((response: any) => {
        reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app-config.service.ts